<template>
  <div>
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #end>
        <el-form-item class="endBtn">
          <el-button type="primary" @click="searchPasted('expired')">已过期</el-button>
          <el-button type="primary" @click="searchPasted('expire_30')">近30天到期</el-button>
          <el-button type="primary" @click="searchPasted('expire_60')">近60天到期</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :btns="btns" :page="page" :limit="limit" :total="total"
      :allBtnWidth="'180px'" :getTotal="getTotal" @onSelectionChange="onSelectionChange"
      @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">
      <template slot="car_type" slot-scope="params">
        <span v-if="params.params.car_type == 1">车头</span>
        <span v-if="params.params.car_type == 2">挂车</span>
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'insurance',
      getListUrl: 'summarize',
      getOptionUrl: 'options',
      formInline: {},
      formCtrl: [
        {
          ...this.ctrls.license,
        },
        {
          label: "种类",
          keyName: "car_type",
          placeholder: "请选择种类",
          type: "select",
          options: [
            { label: '车头', value: 1 },
            { label: '挂车', value: 2 },
          ],
        },
        {
          label: "到期时间",
          keyName: "maturitytime",
          placeholder: "请选择开始结束时间",
          type: "daterange",
          options: [],
        },
      ],
      cols: [
        { keyName: "license", label: "车牌号", minwidth: 120 },
        { keyName: "driver", label: "司机姓名", minwidth: 120 },
        { keyName: "car_type", label: "种类", slot: 'car_type', minwidth: 120 },
        { keyName: "type_name", label: "保险名称", minwidth: 120 },
        { keyName: "maturitytime", label: "到期时间", minwidth: 120 },
      ],
      btns: [
        {
          ...this.editBtn,
          cb: ({ car_id, car_type, license }) => {
            this.$router.push(`/vehicle/insurance2?car_type=${car_type}&carid=${car_id}&license=${license}`);
          },
        },
      ],
    };
  },
  methods: {
    onSearchItemChange({ key }) {
      console.log(key)
      if (this.formInline.expiry_status !== undefined) {
        delete this.formInline.expiry_status;
      }
      if (['car_type', 'maturitytime'].includes(key)) {
        this.page = 1;
        this.getList()
      }
    },
    searchPasted(expiry_status) {
      this.page = 1
      const { license, car_type } = this.formInline
      this.formInline = {
        license,
        car_type,
        expiry_status,
      };
      // console.log({ ...this.formInline });
      this.getList();
    },
    setOptions({ data: { reimburse_user_list } }) {
      this.formCtrl.map(c => {
        if (c.keyName == 'reimburse_user_name' && reimburse_user_list && reimburse_user_list.length) {
          c.options = reimburse_user_list.map(v => {
            return {
              label: v.nickname,
              value: v.nickname,
            }
          })
          // console.log(c.options)
        }
      })
      this.$forceUpdate()
    },
  },
  mounted() {
    // this.getOptions()
  },
};
</script>

<style lang="less" scoped>
.retrieval .el-button {
  padding: 12px;
}
</style>
